/**
 * @author      hugo@zumper.com (Hugo Pineda)
 * @copyright   Copyright (c) 2021, Zumper
 */

/**
 * Takes a event name string and formats according to traktor event names requirements: all uppercased and words separated by underscores
 *
 * @param {string} eventName the traktor event name
 * @returns {string} modified event name to match format requirements
 */
export const toTraktorEventName = (eventName: string) => {
  return eventName
    .toUpperCase()
    .trim()
    .replace(/[^a-zA-Z\d]/g, '_')
    .replace(/_+/g, '_')
}
